import PurchaseDeviceDialog from './PurchaseDeviceDialog';

export default PurchaseDeviceDialog;
